// This function toggles the aria-expanded attribute
function toggleAriaExpanded(event) {
  // Prevent the default behavior of the anchor tag if needed
  // event.preventDefault();

  const clickedNavItem = event.currentTarget;
  const isExpanded = clickedNavItem.getAttribute('aria-expanded') === 'true';

  // First, set all to false
  const allNavItems = document.querySelectorAll('.main-nav-item');
  allNavItems.forEach(function(item) {
    item.setAttribute('aria-expanded', 'false');
  });

  // If the clicked item was previously not expanded, set it to true
  if (!isExpanded) {
    clickedNavItem.setAttribute('aria-expanded', 'true');
  }
}

// Get all elements with the 'main-nav-item' class
const mainNavItems = document.querySelectorAll('.main-nav-item');

// Attach the click event listener to each main nav item
mainNavItems.forEach(function(navItem) {
  navItem.addEventListener('click', toggleAriaExpanded);
});



// The following code is for updating the tab and aria-hidden attributes when toggling between desktop and mobile navigation

//'.header-drawer .navigation' // this is the mobile nav
//'.header-navigation' // this is the desktop nav

function updateNavigationAccessibility() {
    var mobileNav = document.querySelector('.header-drawer .navigation');
    var desktopNav = document.querySelector('.header-navigation');
    var bodyHasDrawerClass = document.body.classList.contains('showing-drawer');

    var mobileNavItems = mobileNav.querySelectorAll('a, button, input, [tabindex]');
    var desktopNavItems = desktopNav.querySelectorAll('a, button, input, [tabindex]');
  

    // Additional elements
    var brandingTitle = document.querySelector('.header-drawer .branding-title a');
    var accountLink = document.querySelector('.header-drawer .drawer-account-link');
    var closeButton = document.querySelector('.header-drawer .drawer-toggle');

    if (bodyHasDrawerClass) {
        // Mobile drawer is visible
        mobileNav.removeAttribute('tabindex');
        mobileNav.removeAttribute('aria-hidden');

        // Make mobile nav items focusable
        mobileNavItems.forEach(function(item) {
            item.removeAttribute('tabindex');
        });

        // Make additional elements tabbable
        brandingTitle.removeAttribute('tabindex');
        accountLink.removeAttribute('tabindex');
        closeButton.setAttribute('tabindex', '0');

        // Desktop nav is not tabbable
        desktopNav.setAttribute('tabindex', '-1');
        desktopNav.setAttribute('aria-hidden', 'true');

        // Ensure children of desktop nav are also not tabbable
        desktopNavItems.forEach(function(item) {
            item.setAttribute('tabindex', '-1');
        });

        // Now set the mobile nav title as the focus
        brandingTitle.focus();



    } else {
        // Desktop nav is visible
        desktopNav.removeAttribute('tabindex');
        desktopNav.removeAttribute('aria-hidden');

        // Make mobile nav and its associated controls not tabbable
        mobileNav.setAttribute('tabindex', '-1');
        mobileNav.setAttribute('aria-hidden', 'true');
        brandingTitle.setAttribute('tabindex', '-1');
        accountLink.setAttribute('tabindex', '-1');
        closeButton.setAttribute('tabindex', '-1');

        // Ensure children of mobile nav are also not tabbable
        var mobileNavItems = mobileNav.querySelectorAll('a, button, input, [tabindex]');
        mobileNavItems.forEach(function(item) {
            item.setAttribute('tabindex', '-1');
        });
    }
}



document.addEventListener('DOMContentLoaded', function() {
    console.log('DOM fully loaded and parsed');

    // This ensures that when the script runs, all elements are accessible
    updateNavigationAccessibility();

    // Other event listeners
    window.addEventListener('load', updateNavigationAccessibility);
    window.addEventListener('resize', debounce(updateNavigationAccessibility, 150));
});

function debounce(func, wait) {
    if (typeof wait === 'undefined') {
        wait = 100;
    }

    var timeout;
    return function() {
        var context = this;
        var args = arguments;

        clearTimeout(timeout);
        timeout = setTimeout(function() {
            func.apply(context, args);
        }, wait);
    };
}

